import React from 'react';
import { stencilsThickness } from 'shared/data/selectOptions';
import SelectComponent from 'shared/components/SelectComponent';

const StencilThickness = (props) => {
  const name = 'stencil_thickness';

  const {
    parameters,
    onChangeParameter,
    groupName,
    inputClassName,
    errorMessage,
    label,
    options,
    required,
    tooltip,
    inputId,
  } = props;

  const onChange = e => onChangeParameter(name, e.target.value);

  return (
    <SelectComponent
      inputId={inputId}
      label={label}
      name={name}
      onChange={onChange}
      required={required}
      options={options}
      tooltip={tooltip}
      selected={parameters[name] || ''}
      groupName={groupName}
      inputClassName={inputClassName}
      errorMessage={errorMessage} />
  );
};

StencilThickness.defaultProps = {
  label: Spree.translations.parameters.stencil_thickness,
  tooltip: Spree.helpForParameters.stencil_thickness,
  required: true,
  inputId: 'stencil-thickness',
  options: stencilsThickness,
};

export default StencilThickness;
